import { createSlice, nanoid } from "@reduxjs/toolkit";
import { act } from "react";

const initialState = {
  contactRef: "",
  priceRef: "",
  userData: "",
  credits: [],
  redirectingPath: "",
  openFeedbackModal: "",
  imgGeneratedArr: [],
};

const Slice = createSlice({
  name: "homePageSlice",
  initialState,
  reducers: {
    // contact form
    ContactForm: (state, action) => {
      const data = {
        id: nanoid(),
        contact: action.payload,
      };
      //   console.log(data);
      state.contactRef = data;
    },

    // price section
    PriceSection: (state, action) => {
      const data = {
        id: nanoid(),
        price: action.payload,
      };
      state.priceRef = data;
    },

    // user data
    UserData: (state, action) => {
      const data = {
        id: nanoid(),
        user: action.payload,
      };
      state.userData = data;
    },

    // credits
    AvalableCredits: (state, action) => {
      const data = {
        id: nanoid(),
        credits: action.payload,
      };
      state.credits.push(data.credits);
    },

    // otp redirecting path
    RedirectingPath: (state, action) => {
      const data = {
        id: nanoid(),
        path: action.payload,
      };
      state.redirectingPath = data;
    },

    // open feedback modal
    OpenFeedbackModal: (state, action) => {
      const data = {
        id: nanoid(),
        openFeedbackModal: action.payload,
      };
      state.openFeedbackModal = data.openFeedbackModal;
    },

    // image generated array
    ImgGeneratedArr: (state, action) => {
      const data = {
        id: nanoid(),
        imgGeneratedArr: action.payload,
      };
      state.imgGeneratedArr.push(data.imgGeneratedArr);
    },
  },
});

export const {
  ContactForm,
  PriceSection,
  UserData,
  AvalableCredits,
  RedirectingPath,
  OpenFeedbackModal,
  ImgGeneratedArr,
} = Slice.actions;
export default Slice.reducer;
